<template>
    <v-container class="fill-height" fluid>
        <v-row class="py-5 py-0" justify="center">
            <v-col class="rounded-lg elevation-5 pa-0" cols="auto">
                <v-card class="authentication">
                    <v-card-title class="text-h5 primary secondary--text">
                        {{ $t('account.createNewSubscription') }}
                    </v-card-title>
                    <div class="d-flex justify-center mt-8">
                        <v-img :src="require('@/assets/logo.png')" contain max-width="50%"/>
                    </div>
                    <v-card-text class="pa-7">
                        <div class="text-center font-weight-bold text-body-1 mb-4">
                            {{ message }}
                        </div>
                        <v-form ref="form" v-model="valid" @submit.prevent="createOrganization">
                            <v-text-field
                                v-model="organization.name"
                                :rules="[$validations.required]"
                                class="mb-2"
                                required>
                                <template v-slot:label>
                                    {{ $t('authentication.subscriptionName') }}<sup>*</sup>
                                </template>
                            </v-text-field>
                            
                            <v-autocomplete
                                v-model="organization.timezone"
                                :items="timezones"
                                :rules="[$validations.required]"
                                class="mb-2"
                                item-text="DisplayName"
                                item-value="Id">
                                <template v-slot:label>
                                    {{ $t('settings.timezone') }}<sup>*</sup>
                                </template>
                            </v-autocomplete>
                            
                            <v-select
                                v-model="organization.googleProductID"
                                :items="productOptions"
                                :rules="[$validations.required]"
                                class="mb-2"
                                item-text="description"
                                item-value="value">
                                <template v-slot:label>
                                    {{ $t('selectSubscription') }}<sup>*</sup>
                                </template>
                            </v-select>
                            
                            <v-btn
                                :disabled="!valid"
                                :loading="loading"
                                block
                                class="elevation-5 mt-5 accentText--text"
                                color="accent"
                                large
                                @click="createOrganization">
                                {{ $t('save') }}
                            </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: "SubscriptionExpired",
  data() {
    return {
      valid: false,
      loading: false,
      organization: {
        name: '',
        timezone: '',
        googleProductID: '',
      },
      timezones: [],
      productOptions: [
        { description: 'Family, max five members, monthly subscription', value: 'five_user_subscription' },
        { description: 'Family, max five members, six months subscription', value: 'five_user_subscription_6m' },
        { description: 'Group, max ten members, monthly subscription', value: 'ten_user_subscription' },
        { description: 'Group, max ten members, six months subscription', value: 'ten_user_subscription_6m' },
        { description: 'Individual monthly subscription', value: 'single_user_subscription' },
      ],
    };
  },
  computed: {
    message() {
      if (this.$store.getters.getOrganizations.length) {
        return this.$t('warnings.noActiveSubscriptionRenew');
      }

      return this.$t('warnings.noActiveSubscription');
    },
  },
  mounted() {
    this.initTimezones();
  },
  methods: {
    initTimezones() {
      const url = this.$store.getters.getUrl('timezones');
      this.axios.get(url).then(({data}) => {
        this.timezones = data.Result;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const country = tz.substring(tz.indexOf('/') + 1);
        const timezone = this.timezones.filter((timezone) => timezone.DisplayName.includes(country));
        if (timezone.length) {
          this.organization.timezone = timezone[0].Id;
        }
      });
    },
    createOrganization() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      
      this.loading = true;
      const url = this.$store.getters.getUrl('organizations');
      const payload = {
        name: this.organization.name,
        timezone: this.organization.timezone,
        googleProductID: this.organization.googleProductID,
        googlePurchaseID: Math.random().toString(36).substring(2, 15),
        appleProductID: '',
        applePurchaseID: '',
      };
      
      this.axios.post(url, payload).then(() => {
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.subscriptionWasCreated'),
        });
        
        this.$store.dispatch('refreshOrganizations').then(() => {
          const organizations = this.$store.getters.getOrganizations;
          if (organizations.length) {
            this.$store.dispatch('setOrganizationId', this.$store.getters.getOrganizations[0].OrganizationID);
            this.$store.dispatch('setHasActiveOrganization',true)
            this.$router.push({name: 'circleMap'});
          }
        });
        
      }).catch((error) => {
        console.error('Error creating organization:', error);
      }).finally(() => {
        this.loading = false;
      });
    },
    resetForm() {
      this.organization = {
        name: '',
        timezone: '',
        googleProductID: '',
      };
      this.$refs.form.resetValidation();
      this.initTimezones();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/components/Authentication/_authentication-basic.scss";
</style>